import React from 'react';
import { Link } from 'react-router';

function PageHeading() {
  return (
    <div>
      <div>
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <span className="breadcrumb">
                  <Link to="/">Home</Link> / Properties
                </span>
                <h3>Properties</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHeading;
